import { render, staticRenderFns } from "./OtpAuth.vue?vue&type=template&id=cfe29f7e"
import script from "./OtpAuth.vue?vue&type=script&lang=js"
export * from "./OtpAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports